import { api } from './index';

export const chatsApi = {
  update(id: number, data: Partial<Chat>) {
    const path = `/api/internal/chats/${id}`;

    return api({
      method: 'patch',
      url: path,
      data,
    });
  },
};
